import ProductList from '@e2grnd/ui-core/dist/components/ProductList/ProductList'

export default function AppRoot() {
  return <ProductList />
}
